export class Header {
    static init(): void {
        if (!document.querySelector(".nhs-header")) return;

        this.setupEventHandlers();
        this.highlightActiveMenuItem();
    }

    private static setupEventHandlers(): void {
        const selectors = {
            mainHeader: ".nhs-header",
            openMenuBtn: "#open-menu-btn",
            openMenuTrigger: "#menu-trigger",
            closeMenuBtn: "#close-menu-btn",
            mobileMenu: ".nhs-nav-sub-navigation-mobile",
            mobileMenuContainer: ".nhs-nav-mobile",
            subMenu: ".nhs-nav-sub",
            logo: ".logo-wrapper a",
        };

        const elements = Object.fromEntries(
            Object.entries(selectors).map(([key, selector]) => [key, document.querySelector<HTMLElement>(selector)])
        );
        
        if (!elements.openMenuTrigger || !elements.mobileMenu || !elements.mobileMenuContainer) return;

        elements.openMenuTrigger.addEventListener("click", () => this.toggleMobileMenu(elements, true));
        elements.openMenuBtn?.addEventListener("click", () => this.toggleMobileMenu(elements, true));
        elements.closeMenuBtn?.addEventListener("click", () => this.toggleMobileMenu(elements, false));
    }

    private static toggleMobileMenu(
        elements: Record<string, HTMLElement | null>,
        toggle: boolean
    ): void {
        elements.mobileMenu?.classList.toggle("active", toggle);
        elements.mobileMenuContainer?.classList.toggle("active", toggle);

        if (elements.openMenuBtn) elements.openMenuBtn.style.display = toggle ? "none" : "block";
        if (elements.closeMenuBtn) elements.closeMenuBtn.style.display = toggle ? "block" : "none";
    }

    private static highlightActiveMenuItem(): void {
        const menuItems = document.querySelectorAll(".nav-menu-item");
        const mobileMenuItems = document.querySelectorAll(".nav-menu-item-mobile");

        menuItems.forEach(item => {
            if (item.getAttribute("href") === window.location.pathname) {
                item.classList.add("active");
            }
        });

        mobileMenuItems.forEach(item => {
            if (item.getAttribute("href") === window.location.pathname) {
                item.classList.add("active");
            }
        });
    }
}
